import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Table from '../../components/Table'
import SimpleCard from '../../components/templates/SimpleCard'
import { tableConfigs, generateTransactionData } from '../../components/DummyMenu/dummyData'

const TransaksiKhusus = () => {
  const [allData, setAllData] = useState([])
  const [paginatedData, setPaginatedData] = useState([])
  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    sort: 'tanggal|desc'
  })

  useEffect(() => {
    // Generate dummy data for special transactions
    setTimeout(() => {
      const dummyData = generateTransactionData(0) // Generate more data for pagination
      setAllData(dummyData)
      setLoading(false)
    }, 500)
  }, [])

  // Apply pagination and sorting
  const applyPaginationAndSort = useCallback(() => {
    let sortedData = [...allData]

    // Apply sorting
    if (pagination.sort) {
      const [sortField, sortDirection] = pagination.sort.split('|')
      sortedData.sort((a, b) => {
        let aValue = a[sortField]
        let bValue = b[sortField]

        // Handle date sorting
        if (sortField === 'tanggal') {
          const [aDay, aMonth, aYear] = aValue.split('/')
          const [bDay, bMonth, bYear] = bValue.split('/')
          aValue = new Date(aYear, aMonth - 1, aDay)
          bValue = new Date(bYear, bMonth - 1, bDay)
        }

        // Handle numeric sorting
        if (sortField === 'nominal' || sortField === 'biaya') {
          aValue = Number(aValue)
          bValue = Number(bValue)
        }

        // Handle string sorting
        if (typeof aValue === 'string' && typeof bValue === 'string') {
          aValue = aValue.toLowerCase()
          bValue = bValue.toLowerCase()
        }

        if (sortDirection === 'asc') {
          return aValue > bValue ? 1 : aValue < bValue ? -1 : 0
        } else {
          return aValue < bValue ? 1 : aValue > bValue ? -1 : 0
        }
      })
    }

    // Apply pagination
    const startIndex = (pagination.page - 1) * pagination.limit
    const endIndex = startIndex + pagination.limit
    const paginated = sortedData.slice(startIndex, endIndex)
    setPaginatedData(paginated)
  }, [allData, pagination])

  useEffect(() => {
    if (allData.length > 0) {
      applyPaginationAndSort()
    }
  }, [applyPaginationAndSort, allData])

  // Handle page change
  const handlePageChange = (page) => {
    setPagination(prev => ({
      ...prev,
      page: page
    }))
  }

  // Handle limit change
  const handleLimitChange = (limit) => {
    setPagination(prev => ({
      ...prev,
      limit: limit,
      page: 1
    }))
  }

  // Handle sort change
  const handleSortChange = (sort) => {
    setPagination(prev => ({
      ...prev,
      sort: sort
    }))
  }



  // Table configuration
  const tableConfig = {
    columns: tableConfigs.transaksiKhusus.columns,
    withIndex: true,
    total: allData.length,
    limit: pagination.limit,
    currentPage: pagination.page,
    showRender: true,
    pagination: true,
    loading: loading,
    sort: pagination.sort,
    collapse: false
  }

  if (loading) {
    return (
      <div className="page-container">
        <div style={{ padding: '40px', textAlign: 'center' }}>
          Loading transaksi khusus data...
        </div>
      </div>
    )
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">{tableConfigs.transaksiKhusus.title}</h1>
        <p className="page-subtitle">{tableConfigs.transaksiKhusus.description}</p>
        {tableConfigs.transaksiKhusus.showSortDaily && (
          <div style={{
            display: 'inline-block',
            padding: '6px 12px',
            backgroundColor: '#e6f2ff',
            color: '#007aff',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: '500',
            marginTop: '8px'
          }}>
            Sort Daily
          </div>
        )}
      </div>

      <SimpleCard>
        <Table
          data={paginatedData}
          config={tableConfig}
          onChangePage={handlePageChange}
          onLimit={handleLimitChange}
          onSort={handleSortChange}

        />
      </SimpleCard>
    </div>
  )
}

export default TransaksiKhusus